"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

const Unlink = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 16,
  height: 15,
  viewBox: "0 0 16 15",
  fill: "none"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  d: "M12 3.333H8.8v1.584H12c1.368 0 2.48 1.158 2.48 2.583a2.592 2.592 0 01-1.848 2.5l1.168 1.2A4.163 4.163 0 0016 7.5a4.256 4.256 0 00-1.172-2.946A3.92 3.92 0 0012 3.334zm-.8 3.334H9.448l1.6 1.666h.152V6.667zM0 1.058L2.488 3.65C1.032 4.267 0 5.758 0 7.5c0 1.105.421 2.165 1.172 2.946A3.92 3.92 0 004 11.666h3.2v-1.583H4c-1.368 0-2.48-1.158-2.48-2.583 0-1.325.968-2.417 2.208-2.558l1.656 1.725H4.8v1.666h2.184L8.8 10.225v1.442h1.384L13.392 15l1.008-1.05L1.016 0 0 1.058z",
  className: "fill"
}));

var _default = Unlink;
exports.default = _default;